export const DEFAULT_PAINT = {
  'circle-color': '#6ebff2',
  'circle-opacity': 0.45,
  'circle-stroke-width': 2,
  'circle-stroke-color': '#6ebff2',
  'circle-radius': 7,
};

export const HOVERED_PAINT = {
  'circle-color': '#1da1f2',
  'circle-opacity': 1,
  'circle-stroke-width': 2,
  'circle-stroke-color': '#003300',
  'circle-radius': 8,
};

export const SELECTED_PAINT = {
  'circle-color': '#33cc33',
  'circle-opacity': 1,
  'circle-stroke-width': 2,
  'circle-stroke-color': '#33cc33',
  'circle-radius': 8,
};

export default { DEFAULT_PAINT, HOVERED_PAINT, SELECTED_PAINT };



// WEBPACK FOOTER //
// ./src/components/Summary/ParkingsMap/parkingsMap.config.js